import { useEffect, useState } from 'react'

const CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline']

export const hasCookiebotConsent = (consentType) => {
  if (typeof window === 'undefined') {
    return false
  }

  return !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent[consentType])
}

const useCookiebotConsent = (consentType) => {
  const [isAllowed, setIsAllowed] = useState(hasCookiebotConsent(consentType))

  useEffect(() => {
    const refreshConsent = () => setIsAllowed(hasCookiebotConsent(consentType))

    CONSENT_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, refreshConsent)
    })

    refreshConsent()

    return () => {
      CONSENT_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, refreshConsent)
      })
    }
  }, [consentType])

  return isAllowed
}

export default useCookiebotConsent